import React from 'react';
import { string, arrayOf, object, bool } from 'prop-types';
import StackableCardWrapper from '../../../components/library/stacking-collapsible-cards/StackableCardWrapper';
import FilingStatusCard from './FilingStatusCard';

const DiyNetfileStatusCard = props => {

    const { id, returnInfo, returnStatii, hideJsonButtons } = props

    const toTitleCase = (str) => {
        // handle casing (this is ugly, I know but if I use css to handle casing, the 'et' 
        // in the french format becomes capilalized, which I don't want)
        return str.replace(/(^|[\s-])\S/g, function (t) { return t.toUpperCase() });
    }

     const clientName = id === 'SPOUSE' ?
        toTitleCase(`${returnInfo.spouseFirstName || ''} ${returnInfo.spouseLastName || ''}`.trim()) :
        toTitleCase(`${returnInfo.primaryFirstName || ''} ${returnInfo.primaryLastName || ''}`.trim())

    let statii = returnStatii

    var acceptedSubmissionTypes = ['CRA', 'REFILECRA', 'RQ', 'T1135']
   
    if (!statii.some((r) => { return acceptedSubmissionTypes.indexOf(r.submissionType) > -1 })) {
        return null;
    }

    return (
        <StackableCardWrapper className='card-filing-status'>
            <FilingStatusCard
                filer={id} clientName={clientName}
                hideJsonButtons={hideJsonButtons}
                returnStatii={returnStatii.filter(r => acceptedSubmissionTypes.includes(r.submissionType) && r.fileContext === id)} />
        </StackableCardWrapper>
    )
}

DiyNetfileStatusCard.propTypes = {
    id: string,
    returnInfo: object,
    returnStatii: arrayOf(object),
    hideJsonButtons: bool
}

export default DiyNetfileStatusCard